import * as React from 'react';
import { Button } from '@cian/ui-kit';

export interface IShowPhoneButtonProps {
  onClick?(): void;
}

export const ShowPhoneButton: React.FC<IShowPhoneButtonProps> = ({ onClick }) => {
  return (
    <Button onClick={onClick} size="M" type="button" data-testid="ShowPhoneButton" fullWidth>
      Показать телефон
    </Button>
  );
};
